import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import CarouselNextArrow from '@icons/CarouselNextArrow'
import CarouselPrevArrow from '@icons/CarouselPrevArrow'
import * as S from './Carousel.styled'

const NextArrow = ({ onClick, className }) => {
  return (
    <S.CarouselNext onClick={onClick} className={className}>
      <CarouselNextArrow />
    </S.CarouselNext>
  )
}

const PrevArrow = ({ onClick, className }) => {
  return (
    <S.CarouselPev onClick={onClick} className={className}>
      <CarouselPrevArrow />
    </S.CarouselPev>
  )
}

const Carousel = ({ children }) => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyLoad: true,
    focusOnSelect: false,
    draggable: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1366,
        settings: { slidesToShow: 3.15, slidesToScroll: 3.15 },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2.15, slidesToScroll: 2.15 },
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
    appendDots: (dots) => <S.CarouselIndicators>{dots}</S.CarouselIndicators>,
  }

  return (
    <S.Carousel>
      <Slider {...settings}>{children}</Slider>
    </S.Carousel>
  )
}

export default Carousel
